import { RowCrudStatus } from "../../common/types";
import {
  PublisherCollectingSociety,
  PublisherCollectingSociety_CreateInput,
  PublisherCollectingSociety_UpdateInput,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { collectiveManagementSocietyDisplayId } from "../../collectiveManagementSociety/store/CollectiveManagementSocietyCommonStore";

export type PublisherCollectingSocietyValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  __collectingSociety: string;
  showCollectingSociety: { displayId: string; id: string } | null;
  cmsAccountNumber: string;
};

export type PublisherCollectingSocietyErrorsType = {
  collectingSociety?: { message: string; fieldLabel: string };
  cmsAccountNumber?: { message: string; fieldLabel: string };
};

export function PublisherCollectingSocietyValuesInit(): PublisherCollectingSocietyValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    __collectingSociety: "",
    showCollectingSociety: null,
    cmsAccountNumber: "",
  };
}

export type PublisherCollectingSocietyType =
  | PublisherCollectingSociety
  | PublisherCollectingSocietyValuesType;

export function publisherCollectingSocietyDisplayId(
  source: Partial<PublisherCollectingSociety>,
  _langStore: LangStore
) {
  return source.collectingSociety
    ? collectiveManagementSocietyDisplayId(source.collectingSociety, _langStore)
    : _langStore.emptyStringSymbol;
}

export function getPublisherCollectingSocietyValues(
  source: PublisherCollectingSocietyType,
  _langStore: LangStore,
  _duplicated: boolean = false
): PublisherCollectingSocietyValuesType {
  const entityValues = PublisherCollectingSocietyValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : publisherCollectingSocietyDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.showCollectingSociety =
    "collectingSociety" in source && source.collectingSociety
      ? {
          id: source.collectingSociety.id,
          displayId: collectiveManagementSocietyDisplayId(
            source.collectingSociety,
            _langStore
          ),
        }
      : "showCollectingSociety" in source && source.showCollectingSociety
      ? {
          id: source.showCollectingSociety.id,
          displayId: source.showCollectingSociety.displayId,
        }
      : null;
  entityValues.__collectingSociety =
    entityValues.showCollectingSociety?.displayId || "";
  entityValues.cmsAccountNumber = source.cmsAccountNumber;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getPublisherCollectingSocietyUpdateInput(
  values: PublisherCollectingSocietyValuesType
): PublisherCollectingSociety_UpdateInput {
  return {
    id: values.id,
    version_: values.version_,
    collectingSocietyId: values.showCollectingSociety?.id || "",
    cmsAccountNumber: values.cmsAccountNumber,
  };
}

export function getPublisherCollectingSocietyCreateInput(
  values: PublisherCollectingSocietyValuesType
): PublisherCollectingSociety_CreateInput {
  return {
    collectingSocietyId: values.showCollectingSociety?.id || "",
    cmsAccountNumber: values.cmsAccountNumber,
  };
}
